export default class PrizeAsset {
    constructor(data) {
        Object.assign(this, data);
    }
}